import React, { useEffect } from 'react'

const SignReact = (props) => {
  useEffect(() => {
    // Dynamically load the script only once
    const script = document.createElement('script')
    script.setAttribute('src', `${process.env.BASE_URL}/signpanda_script.js`)

    script.addEventListener(
      'load',
      () => {
        console.log('Script loaded successfully')
        let root = document.getElementById('sign-react-div')
        console.log('check root', root)
        if (!!root) {
          root.classList.remove('appointo-loader')
        }
      },
      false
    )

    document.body.appendChild(script)

    // Cleanup function to remove the script on unmount (optional)
    return () => {
      if (script) {
        document.body.removeChild(script)
      }
    }
  }, [])

  useEffect(() => {
    const originalSubmitDetail = window.submitDetail

    window.submitDetail = function (...args) {
      if (originalSubmitDetail) {
        originalSubmitDetail.apply(this, args)
      }

      const payload = {
        type: 'triggerParentFunction',
        payload: args[0],
      }

      window.parent.postMessage(payload, '*')
    }

    return () => {
      if (originalSubmitDetail) {
        window.submitDetail = originalSubmitDetail // Restore the original function
      }
    }
  }, [])

  return <div id="sign-react-div" className="appointo-loader"></div>
}

export default SignReact
